import { axios, withPartialContent } from 'shared/services/axios'

export function fetchItems(boardId, params, abortSignal) {
  return axios.post(`/api/v1/boards/${boardId}/items`, {
    filters: params.activeFilters,
    page: params.page,
    per_page: params.perPage,
    minimized: params.minimized
  }, { signal: abortSignal })
    .then(response => response.data)
}

export function fetchItem(itemId) {
  return axios.get(`/api/v1/items/${itemId}`)
    .then(response => response.data)
}

export function fetchItemCanonicalCategories(itemId) {
  return axios.get(`/api/v1/items/${itemId}/canonical_categories`)
    .then(response => response.data)
}

export function createItem(params) {
  return axios.post('/api/v1/items', {
    ...params
  })
    .then(response => response.data)
}

export function updateItem(item) {
  return axios.put(`/api/v1/items/${item.id}`, item)
    .then(response => response.data)
}

export function deleteItem(itemId) {
  return axios.delete(`/api/v1/items/${itemId}`)
}

export const createManyItems = withPartialContent(
  ({ params, boardId, guid = null }) => {
    return axios.post('/api/v1/items/bulk', {
      data: params,
      board_id: boardId,
      guid
    })
  })

export const createFileItem = withPartialContent(
  ({ file, boardId, guid = null }) => {
    return axios.post('/api/v1/items/files', {
      ...file,
      board_id: boardId,
      guid
    })
  })

export const copyItem = (itemId, boardId) => {
  return axios.post(`/api/v1/items/${itemId}/copy`, { board_id: boardId })
    .then(response => response.data)
}

export const syncBoxItems = withPartialContent(
  ({ boardId, guid = null }) => {
    return axios.post('/api/v1/items/sync', {
      board_id: boardId,
      guid
    })
  })

export const updateItemStatus = (itemId, itemVisibility) => {
  return axios.put(`/api/v1/items/${itemId}`, {
    id: itemId,
    item_visibility: {
      status: itemVisibility.status,
      start_date: itemVisibility.start_date,
      end_date: itemVisibility.end_date
    }
  })
}

export const detachItem = (itemId) => {
  return axios.post(`/api/v1/items/${itemId}/detach`)
    .then(response => response.data)
}

export const validateItemSlug = (itemId, slug) => {
  return axios.post(`/api/v1/items/${itemId}/slugs/validations`, { slug })
}

export function setItemSlug(itemId, slug) {
  return axios.post(`/api/v1/items/${itemId}/slugs`, { slug })
    .then(response => response.data)
}
